var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5002 28.9H21.5002V17.9154H12.5002V28.9ZM1.7002 28.9H10.7002V5.09998H1.7002V28.9ZM23.3002 28.9H32.3002V17.9154H23.3002V28.9ZM12.5002 5.09998V16.0846H32.3002V5.09998H12.5002Z","fill":"#B36CF1"}));
}

Grid.defaultProps = {"viewBox":"0 0 34 34","fill":"none"};

module.exports = Grid;

Grid.default = Grid;
